import { configureStore } from '@reduxjs/toolkit';
import commodityDetailsReducer from './commodityDetails/commodityDetailsSlice';
import datavisualizationReducer from './datavisualization/datavisualizationSlice';
import dashboardReducer from './dashboard/dashboardSlice';
import scenarioModellingReducer from './scenarioModelling/scenarioModellingSlice';

const store = configureStore({
  reducer: {
    commodityOverview: commodityDetailsReducer,
    datavisualization: datavisualizationReducer,
    dashboard: dashboardReducer,
    scenarioModelling: scenarioModellingReducer,
  },
});

export default store;

export type AppDispatch = typeof store.dispatch;
